







































































































































































import { BaseStepForm } from '@/components/forms/onboarding/BaseStepForm';
import { AdminRouteName, FormScope, ONBOARDING_FORMS } from '@/constants';
import { IODUserForm } from '@/model';
import { IUser, UserOnboardingStatus } from '@homeserve/od-typings/api';
import { Nullable } from '@homeserve/od-typings/utils';
import { userHelper } from '@homeserve/vue-api-plugin';
import { authHelper } from '@homeserve/vue-auth-plugin';
import { Component, Vue } from 'vue-property-decorator';
import { State } from 'vuex-class';
import UserForm from '../components/forms/onboarding/UserForm.vue';
import { createUserInfo, handleUserFormError } from '../utils';

@Component({
  components: {
    UserForm,
  },
  $_veeValidate: {
    validator: 'new',
  },
})
export default class Home extends Vue {
  @State('userAuthenticated', { namespace: 'auth' })
  public isAuthenticated!: boolean;

  @State('user', { namespace: 'api/user/user' })
  public user!: Nullable<IUser>;

  public model: IODUserForm = { ...ONBOARDING_FORMS[FormScope.USER] };

  public userFormLoading = false;

  public get isUserStatusDone() {
    return this.user && this.user.userStatus === UserOnboardingStatus.DONE;
  }

  public async saveForm() {
    this.errors.remove('onboarding');

    const form = this.$refs.userForm;

    if (form && form instanceof BaseStepForm) {
      const isValid = await form.isValid();

      if (!isValid) {
        return;
      }
    }

    this.userFormLoading = true;

    try {
      await createUserInfo({ ...this.model }, this.isAuthenticated, this.$store);

      const { error: fetchUserError } = await userHelper.fetchUser(this.$store);

      if (fetchUserError) {
        this.errors.add({
          field: 'onboarding',
          msg: this.$t('errors.unexpected').toString(),
        });

        return await authHelper.logout(this.$store);
      }

      this.$router.push({ name: 'onboarding' });
    } catch (error) {
      handleUserFormError(error, this.errors);
    } finally {
      this.userFormLoading = false;
    }
  }

  public get AdminRouteName() {
    return AdminRouteName;
  }
}
